const actions = {
  SET_USER_PERMISSION: 'userSettings/SET_USER_PERMISSION',
};

export default actions;
